import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'shared/hooks';

import { SendLinkError, sendPortalLink } from '../loginHelpApi';

export function useSendPortalLinkMutation() {
    const { t } = useTranslation('auth', { keyPrefix: 'loginHelp.sendLink' });
    const { showSuccess, showError } = useToast();

    return useMutation({
        mutationFn: sendPortalLink,

        onSuccess: () => {
            showSuccess(t('success'), 'login-help-send-link-success');
        },

        onError: (error: Error) => {
            const errorCode = error instanceof SendLinkError
                ? error.errorCode
                : 'unknown';

            showError(t(`errors.${ errorCode }`), 'login-help-send-link-error');
        }
    });
}
